<template>
  <div class="transaction-item basic-box">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="row no-gutters header-row">
          <div class="image-wrapper">
            <user-image :user="transaction.receiverUser" class="user-image" />
          </div>
          <div class="participants">
            <router-link
              class="user-name-link"
              :to="`/users/${transaction.receiverUser._id}`"
              >{{ transaction.receiverUser.userName }}</router-link
            >
            <div
              class="amount"
              v-if="
                loggedInUserProfile.role === 1 ||
                loggedInUserProfile.company.privacyLevel === 0
              "
            >
              {{
                $t("transaction.card.points", { points: transaction.sumAmount })
              }}
            </div>
          </div>
          <div v-if="recommendation" class="info">
            <div class="info-text">{{$t('feedback.recommendation.infoText')}}</div>
            <img src="/static/images/info.svg" alt="info text"/>
          </div>
          <div class="category">
            <div
              class="category-icon"
              :title="transaction.coreValue.name"
              v-html="transaction.coreValue.emoji"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-12 reason">"{{ transaction.reason }}"</div>
    </div>
    <div class="row no-gutters">
      <div class="col-6 time" :title="transaction.updatedAt | formatDate">
        {{ transaction.updatedAt | moment("from") }}
      </div>
      <div class="col-6">
        <div class="sender-users">
          <div
            class="sender-user"
            v-for="(user, index) in transaction.senderUsers"
            :key="index"
          >
            <div class="image-wrapper">
              <user-image :user="user" class="user-image" />
            </div>
          </div>
          <font-awesome-icon
            @click="duplicate"
            :icon="'hands-clapping'"
            class="duplicate-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserImage from "@/components/shared/users/UserImage";
import FeedbackModal from "@/components/shared/modals/FeedbackModal";
import CategoryIcons from "@/components/shared/categoryIcons";

export default {
  name: "Transaction",
  components: {
    UserImage,
  },
  mixins: [CategoryIcons],
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    recommendation: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    duplicate() {
      this.$eventBus.showModal({
        bind: {
          is: FeedbackModal,
          receiverUserId: this.transaction.receiverUser._id,
          initialReason: this.transaction.reason,
          initialAmount: this.transaction.amount,
          initialCategory: this.transaction.category,
          parentId: this.transaction.parentId || this.transaction._id,
        },
      });
    },
    iconForCategory(category) {
      const categories = ["seedling", "rocket", "smile-beam", "users"];
      return categories[category];
    },
  },
  computed: {
    ...mapGetters({
      loggedInUserProfile: "users/loggedInUserProfile",
    }),
  },
};
</script>

<style lang="scss" scoped>
.transaction-item {
  margin: 10px 0;
  background-color: white;
  .row {
    margin: 5px 0;
  }
  .amount {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #22252a;
    opacity: 0.6;
  }
  .participants {
    text-align: left;
    margin-left: 15px;
    padding-top: 3px;
  }
  .reason {
    color: $primary-color;
    font-style: italic;
    min-height: 60px;
    text-align: left;
    display: flex;
    align-items: center;
  }
  .time {
    text-align: left;
    color: #cccccc;
  }
  .category {
    text-align: right;
    color: #ccc;
    .category-icon {
      max-height: 32px;
    }
  }
  .header-row {
    display: flex;
    align-items: center;
    .image-wrapper {
      width: 56px;
      height: 56px;
    }
    .user-name-link {
      font-size: 20px;
    }
    .category {
      flex-grow: 1;
    }
    .info {
      position: absolute;
      top: -12px;
      right: 2px;
      cursor: help;
      img {
        max-width: 20px;
        opacity: .6;
      }
      .info-text {
        display:none;
        position: absolute;
        font-size: 10px;
        width: 150px;
        right: 0;
        top: -30px;
        background-color: $base-font-color;
        color: #FFF;
        border-radius: 8px;
        padding: 2px;
      }
      &:hover {
        .info-text {
          display: block;
        }
      }
    }
  }
  .sender-users {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;
    .duplicate-icon {
      cursor: pointer;
      color: #fff;
      font-size: 30px;
      margin-left: -15px;
      padding: 5px;
      background-color: $primary-hover-color;
      border-radius: 15px;
      border: 1px solid white;
      -webkit-transition: all 350ms ease-out;
      -moz-transition: all 350ms ease-out;
      -o-transition: all 350ms ease-out;
      -ms-transition: all 350ms ease-out;
      transition: all 350ms ease-out;
      z-index: 2;
    }
    .sender-user {
      -webkit-transition: all 350ms ease-out;
      -moz-transition: all 350ms ease-out;
      -o-transition: all 350ms ease-out;
      -ms-transition: all 350ms ease-out;
      transition: all 350ms ease-out;
      margin-left: -15px;
      .image-wrapper {
        width: 30px;
        height: 30px;
        >>> img {
          border: 2px solid white;
        }
      }
    }
    &:hover {
      .duplicate-icon,
      .sender-user {
        -webkit-transition: all 350ms ease-in;
        -moz-transition: all 350ms ease-in;
        -o-transition: all 350ms ease-in;
        -ms-transition: all 350ms ease-in;
        transition: all 350ms ease-in;
        margin-left: 0;
      }
    }
  }
}
</style>

